<template>
  <div>
    <div v-if="printData['salPriceFormat' + 'IsShow'] == 'Y' || printData['midPriceFormat' + 'IsShow'] == 'Y' || printData['invPriceFormat' + 'IsShow'] == 'Y' || printData['priceFormat' + 'IsShow'] == 'Y'">
      <p>
        <span v-if="printData['invQtyFormat' + 'IsShow'] == 'Y'">{{item.invQtyFormat}}</span>
        <span v-else>{{item.billQtyFormat}}</span>
      </p>
      <p class="flex justify_space-between">
        <span v-if="printData['priceFormat' + 'IsShow'] == 'Y'">{{item.priceFormat}}</span>
        <span v-else>
          <span v-if="printData['salPriceFormat' + 'IsShow'] == 'Y'">{{item.salPriceFormat}}</span>
          <span v-if="printData['midPriceFormat' + 'IsShow'] == 'Y'">{{item.midPriceFormat}}</span>
          <span v-if="printData['invPriceFormat' + 'IsShow'] == 'Y'">{{item.invPriceFormat}}</span>
        </span>
        <span>{{item.totalAmt}}元</span>
      </p>
    </div>
    <div v-else>
      <p class="flex justify_space-between">
        <span v-if="printData['invQtyFormat' + 'IsShow'] == 'Y'">{{item.invQtyFormat}}</span>
        <span v-else>{{item.billQtyFormat}}</span>
        <span>{{item.totalAmt}}元</span>
      </p>
    </div>
    <p v-if="printData['salBarCode' + 'IsShow'] == 'Y' && item.salBarCode">大单位条码：{{item.salBarCode}}</p>
    <p v-if="printData['midBarCode' + 'IsShow'] == 'Y' && item.midBarCode">中单位条码：{{item.midBarCode}}</p>
    <p v-if="printData['invBarCode' + 'IsShow'] == 'Y' && item.invBarCode">小单位条码：{{item.invBarCode}}</p>
    <p v-if="printData['productionDate' + 'IsShow'] == 'Y' && item.productionDate">生产日期：{{item.productionDate}}</p>
    <p class="flex justify_space-between">
      <span>
        <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y' || printData['midRetailPrice' + 'IsShow'] == 'Y' || printData['invRetailPrice' + 'IsShow'] == 'Y'">建议零售价：</span>
        <span v-if="printData['salRetailPrice' + 'IsShow'] == 'Y'">{{item.salRetailPrice}}</span>
        <span v-if="printData['midRetailPrice' + 'IsShow'] == 'Y'">{{item.midRetailPrice}}</span>
        <span v-if="printData['invRetailPrice' + 'IsShow'] == 'Y'">{{item.invRetailPrice}}</span>
      </span>
      <span v-if="printData['itemWeight' + 'IsShow'] == 'Y'">重量：{{item.itemWeight}}</span>
    </p>
    <p class="flex justify_space-between">
      <span v-if="printData['productFactoryName' + 'IsShow'] == 'Y' && item.productFactoryName">生产厂家：{{item.productFactoryName}}</span>
      <span v-if="printData['itemValid' + 'IsShow'] == 'Y'">保质期：{{item.itemValid}}</span>
    </p>
    <p v-if="printData['remark' + 'IsShow'] == 'Y' && item.remark">备注：{{item.remark}}</p>
  </div>
</template>

<script>
export default {
  props: {
    printData: Object,
    item: Object,
  },
}
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
.justify_space-between {
  justify-content: space-between;
}
.center {
  text-align: center;
}
.dividerBox {
  position: relative;
  .divider {
    width: 100%;
    position: absolute;
    top: 50%;
  }
  span {
    background-color: #fff;
    position: relative;
  }
}
.divider {
  height: 1px;
  border-top: 1px dashed #000;
}
.tableHead {
  display: flex;
}
.tableBody .product {
  .td + .td {
    margin-left: 12px;
  }
}
.th, .td {
  flex-shrink: 0;
  text-align: center;
  flex: 1;
}
</style>